import React, {useEffect, useState} from 'react';
import Page from "../Components/Page";
import AirflowDagLogs from "../Components/airflow/dagLogs/AirflowDagLogs";
import {invokeDAGviaApiPost} from "../../Api/invokeDag";
import {toastError, toastSuccess} from "../../utils/toast";
import {toast} from "react-toastify";
import SelectDropdown from "../Components/Dropdowns/SelectDropdown";
import {makeApolloClientCall} from "../../Api/makeApolloApiCall";
import {wrapValueInOptionStructure} from "../../utils/maybeAddLabelToOptions";
import {LoadingWrapper} from "../Components/LoadingWrapper";
import {Breadcrumbs} from "../Components/Breadcrumbs";

const PiEngineSnapshot = () => {
    const DAG_NAME = "ingest_pi_engine_snapshot"

    const [loading, setLoading] = useState(true);
    const [selectedPeriod, setSelectedPeriod] = useState(undefined)
    const [periodOptions, setPeriodOptions] = useState([]);

    useEffect(() => {
        setLoading(true);
        Promise.all([
            makeApolloClientCall(`{ periods(periodEndWeeksOnly: true) { periodAbbreviation } }`)
        ])
            .then(([
                       periodResults,
                   ]) => {
                const periodOptions = periodResults.periods
                    .map(period => period.periodAbbreviation)
                    .sort()
                    .reverse()
                    .map(mp => wrapValueInOptionStructure(mp));
                setPeriodOptions(periodOptions);
            }).finally(() => setLoading(false));
    }, [])

    const triggerDag = () => {
        invokeDAGviaApiPost(DAG_NAME, {period: selectedPeriod})
            .then((response) => {
                if (response?.apiError)
                    toastError(toast, `${DAG_NAME} DAG trigger failed with error ${JSON.stringify(response.apiError)}`)
                else
                    toastSuccess(toast, `${DAG_NAME} DAG triggered successfully`)
            })
            .catch(e => {
                toastError(toast, `${DAG_NAME} DAG trigger failed with error ${JSON.stringify(e)}`)
            })
    }
    return <Page name={"PI Engine Snapshot"} beta={true}
                 breadCrumbs={<Breadcrumbs items={[{label: "ADP"}, {label: "PI Engine Snapshot"}]}/>}>
        <div className={"pi-engine-snapshot-container"}>
            <LoadingWrapper loading={loading}>
                <div className={"period-dropdown-container"}>
                    <SelectDropdown id={"period_dropdown"}
                                    dataTestId={"period_dropdown"}
                                    inputLabel={"Period"}
                                    selectValue={selectedPeriod}
                                    options={periodOptions}
                                    onChange={(option) => setSelectedPeriod(option.value)}
                    />
                </div>
                <div className={"trigger-dag-submit-button-container"}>
                    <button type="button"
                            className="button primary measures-trigger-submit"
                            onClick={triggerDag}
                            disabled={!selectedPeriod}
                    >
                        Trigger Dag
                    </button>
                </div>
            </LoadingWrapper>
        </div>
        <div className="sld-dag-airflowlogs-container" data-testid="airflow-logs-container">
            <h5>Airflow Logs</h5>
            <AirflowDagLogs processName={DAG_NAME}/>
        </div>
    </Page>;
};

export default PiEngineSnapshot;